import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useSendResetPasswordEmail = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(input => client.auth.sendResetPasswordEmail(input), useMutationOptions);
};
//# sourceMappingURL=useSendResetPasswordEmail.js.map